// extracted by mini-css-extract-plugin
export default {"container":"MerchantPageByLinkContainer_container__HAS7B"};